import React from 'react';
import { RouteObject } from 'react-router-dom';
import Layout from '../layouts/MainLayout';
import DashboardPage from '../pages/dashboard';
import ProductsPage from '../pages/products';
import DuplicateProductsPage from '../pages/duplicate-products';
import RegionalRecommendationsPage from '../pages/regional-recommendations';
import ExternalProductsPage from '../pages/external-products';
import OrdersPage from '../pages/orders';
import ContentPage from '../pages/content';
import MarketingPage from '../pages/marketing';
import UsersPage from '../pages/users';
import SettingsPage from '../pages/settings';
import LotteryPage from '../pages/lottery';
import LotteryDetailPage from '../pages/lottery/detail';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '',
        element: <DashboardPage />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'products',
        element: <ProductsPage />,
      },
      {
        path: 'duplicate-products',
        element: <DuplicateProductsPage />,
      },
      {
        path: 'regional-recommendations',
        element: <RegionalRecommendationsPage />,
      },
      {
        path: 'external-products',
        element: <ExternalProductsPage />,
      },
      {
        path: 'orders',
        element: <OrdersPage />,
      },
      {
        path: 'content',
        element: <ContentPage />,
      },
      {
        path: 'marketing',
        element: <MarketingPage />,
      },
      {
        path: 'lottery',
        element: <LotteryPage />,
      },
      {
        path: 'lottery/:id',
        element: <LotteryDetailPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
    ],
  },
];

export default routes; 
